// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".masthead[data-v-0e497a86]{padding-bottom:10px;border-bottom:1px solid var(--border);margin-bottom:10px}HEADER[data-v-0e497a86]{margin:0}.actions[data-v-0e497a86]{display:flex;justify-content:flex-end;align-items:center}.actions .btn[data-v-0e497a86]{margin-left:10px}", ""]);
// Exports
module.exports = exports;
